import React, { useState, useEffect } from "react";
import SkillsCard from "./SkillsCard";
import { motion } from "framer-motion";

const Skills = () => {
  const [skillsData, setSkillsdata] = useState([
    {
      name: "Programming Languages",
      collection: ["C++", "Python", "Java", "JavaScript", "HTML", "CSS", "SQL"],
    },
    {
      name: "Frontend Development",
      collection: ["React.js", "Tailwind", "Redux", "Saga"],
    },
    {
      name: "Backend Development",
      collection: ["Node.js", "Express.js", "MongoDB", "MySQL"],
    },
    {
      name: "Tools & Technologies",
      collection: ["Git", "VSCode", "Docker", "Postman"],
    },
    {
      name: "Other Skills",
      collection: ["Debugging", "Problem Solving"],
    },
  ]);

  const baseurl = process.env.REACT_APP_BASE_URL;
  const added_url = "skills";

  const fetchhandle = async () => {
    try {
      console.log(baseurl + added_url);
      const response = await fetch(baseurl + added_url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const results = await response.json();
      setSkillsdata(results);
      console.log(results);
    } catch (error) {
      console.error("An error occurred while fetching the data:", error);
    }
  };

  useEffect(() => {
    fetchhandle();
  }, []);

  return (
    <motion.div
      className="Skills"
      id="Skills"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}>
      <motion.div
        className="skillsHeading"
        initial={{ y: -20, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        viewport={{ once: true }}>
        Skills
      </motion.div>

      <motion.div
        className="skillsContent1"
        initial="hidden"
        whileInView="visible"
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1, transition: { staggerChildren: 0.3 } },
        }}
        viewport={{ once: true }}>
        {skillsData.map((item, index) => (
          <SkillsCard data={item} key={index} />
        ))}
      </motion.div>
    </motion.div>
  );
};

export default Skills;
